__turbopack_context__.v({
  "initialLoadBackground": "body-module__WYoDpW__initialLoadBackground",
});
